/* unplugin-vue-components disabled */import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-2 gap-1"
};
const _hoisted_2 = ["onMouseover"];
const _hoisted_3 = ["src", "onClick"];
const _hoisted_4 = {
  key: 0,
  class: "absolute bottom-0 left-0 text-white h-8 bg-base-100 w-full opacity-50 z-20"
};
const _hoisted_5 = {
  class: "flex justify-end items-center pr-2 leading-8"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = ["onMouseover"];
const _hoisted_8 = ["src", "onClick"];
const _hoisted_9 = {
  key: 0,
  class: "absolute bottom-0 left-0 text-white h-8 bg-base-100 w-full opacity-50 z-20"
};
const _hoisted_10 = {
  class: "flex justify-end items-center pr-2 leading-8"
};
const _hoisted_11 = ["href"];
export default {
  __name: 'UnsplashImagesGrid',
  props: {
    pictures: {
      type: Array,
      required: true
    }
  },
  emits: ['handle-image'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const activeArtist = ref('');
    const half = ref(Math.ceil(props.pictures.length / 2));
    const firstHalf = ref(props.pictures.slice(0, half.value));
    const secondHalf = ref(props.pictures.slice(half.value));
    watch(() => props.pictures.length, () => {
      half.value = Math.ceil(props.pictures.length / 2);
      firstHalf.value = props.pictures.slice(0, half.value);
      secondHalf.value = props.pictures.slice(half.value);
    });
    function setActiveHover(id) {
      activeArtist.value = id;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(firstHalf), image => {
        return _openBlock(), _createElementBlock("div", {
          key: image.id
        }, [_unref(firstHalf)?.length ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "relative mb-1 border-[0.2px] border-white cursor-pointer justify-self-auto",
          onMouseover: $event => setActiveHover(image.id),
          onMouseleave: _cache[0] || (_cache[0] = $event => setActiveHover(''))
        }, [_createElementVNode("img", {
          src: image.urls?.small,
          alt: "image",
          class: "w-full h-full object-contain",
          onClick: $event => emit('handle-image', image)
        }, null, 8, _hoisted_3), _unref(activeArtist) === image.id ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, [_createElementVNode("a", {
          href: `${image.user?.links?.html}?utm_source=brand_in_color&utm_medium=referral`,
          target: "_blank",
          rel: "noopener noreferrer"
        }, " by " + _toDisplayString(image.user?.name), 9, _hoisted_6)])])) : _createCommentVNode("", true)], 40, _hoisted_2)) : _createCommentVNode("", true)]);
      }), 128))]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(secondHalf), image => {
        return _openBlock(), _createElementBlock("div", {
          key: image.id
        }, [_unref(secondHalf)?.length ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "relative mb-1 border-[0.2px] border-white cursor-pointer justify-self-auto",
          onMouseover: $event => setActiveHover(image.id),
          onMouseleave: _cache[1] || (_cache[1] = $event => setActiveHover(''))
        }, [_createElementVNode("img", {
          src: image.urls?.small,
          alt: "image",
          class: "w-full h-full object-contain",
          onClick: $event => emit('handle-image', image)
        }, null, 8, _hoisted_8), _unref(activeArtist) === image.id ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, [_createElementVNode("a", {
          href: `${image.user?.links?.html}?utm_source=brand_in_color&utm_medium=referral`,
          target: "_blank",
          rel: "noopener noreferrer"
        }, " by " + _toDisplayString(image.user?.name), 9, _hoisted_11)])])) : _createCommentVNode("", true)], 40, _hoisted_7)) : _createCommentVNode("", true)]);
      }), 128))])]);
    };
  }
};